(()=>{
  if(window.__vivaAskResponseNormalizer)return;
  window.__vivaAskResponseNormalizer=true;
  const nativeFetch=window.fetch.bind(window);
  const asArray=value=>{
    if(Array.isArray(value))return value.filter(v=>v!=null&&String(v).trim()!=='').map(v=>String(v).trim());
    if(value==null)return [];
    if(typeof value==='string')return value.trim()?[value.trim()]:[];
    return [String(value)];
  };
  const normalize=data=>{
    if(!data||typeof data!=='object')return data;
    const analyze=data.stages?.analyze;
    if(analyze&&typeof analyze==='object'){
      analyze.keep=asArray(analyze.keep);analyze.move=asArray(analyze.move);analyze.add_roles=asArray(analyze.add_roles);
    }
    const visual=data.stages?.visualize;
    if(visual&&typeof visual==='object'&&visual.status==='ready'&&visual.verified===true){
      visual.verified_data_url=visual.verified_data_url||visual.data_url||'';
      visual.verified_image_url=visual.verified_image_url||visual.url||visual.generated_image_url||'';
    }
    const sell=data.stages?.sell;
    if(sell&&typeof sell==='object')for(const key of ['good','better','complete'])if(sell[key]&&typeof sell[key]==='object'&&!Array.isArray(sell[key].items))sell[key].items=[];
    return data;
  };
  window.fetch=async(input,init)=>{
    const url=typeof input==='string'?input:input?.url||'',isAsk=/\/api\/ask-viva(?:\?|$)/.test(url);
    const response=await nativeFetch(input,init);if(!isAsk)return response;
    try{
      const data=normalize(await response.clone().json()),headers=new Headers(response.headers);
      headers.set('Content-Type','application/json');
      return new Response(JSON.stringify(data),{status:response.status,statusText:response.statusText,headers});
    }catch(_){return response;}
  };
})();
